"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorCodes = void 0;
const exceptions_1 = require("./exceptions");
function handleErrorCodes(errorCode, errorKey) {
    switch (errorCode) {
        case 404:
            return handleNotFound(errorKey);
        case 403:
            return handleForbidden(errorKey);
        case 302: // redirects are handled elsewhere
        case 301:
        default:
    }
}
exports.handleErrorCodes = handleErrorCodes;
function handleNotFound(errorKey) {
    switch (errorKey) {
        case 'deviation_not_found':
            return exceptions_1.DeviationNotFoundException('Deviation not found');
        default:
            return exceptions_1.NotFoundException('Not found');
    }
}
function handleForbidden(errorKey) {
    return exceptions_1.ForbiddenException('Forbidden');
}
//# sourceMappingURL=errorCodes.js.map